import { Box } from "@mui/material";
import React from "react";

import { ImageCanvas } from "components/common/ImageCanvas";
import { getIQImage } from "features/canvas/utils";
import { CanvasAnnotation } from "types/imageAnnotations";
import { ImageQuery } from "types/imageQueries";

export interface ExampleImageThumbnailProps {
  exampleImageQuery: ImageQuery;
  canvasRois: CanvasAnnotation[];
  handleOpen: () => void;
}

export function ExampleImageThumbnail(props: ExampleImageThumbnailProps) {
  const { exampleImageQuery, canvasRois, handleOpen } = props;

  const [imageStatus, setImageStatus] = React.useState<"loading" | "loaded" | "failed">("loading");

  const image = React.useMemo(() => {
    const img = getIQImage(exampleImageQuery.iq_id);
    img.onload = () => {
      setImageStatus("loaded");
    };
    return img;
  }, [exampleImageQuery.iq_id]);

 return (
      <Box
        data-testid={`example-thumbnail-image-${exampleImageQuery.iq_id}`}
        onClick={handleOpen}
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          cursor: "pointer",
        }}
      >
        <ImageCanvas
          imageData={[image, imageStatus]}
          annotations={canvasRois}
          style={{ cursor: "pointer", width: "100%", height: "100%" }}
        />
      </Box>  
  );
}
